<template>
	<section class="sub_container">
    <div class="search_form">
      <h2>매출 마감 실적</h2>
      <div class="contents">
        <div class="row">
          <div class="cell">
            <label>기준일</label>
            <div class="cell_se_input4_date" style="border-left: 0;">
              <div class="date_wrap-n bordn0">
                <div class="date_input-n">
                  <span><inputDate placeholder="조회시작일" id="fromDate" v-model="fromDate" /></span>
                </div>
                <div class="date_input-n pl5">
                  <span><inputDate placeholder="조회종료일" id="toDate" v-model="toDate" /></span>
                </div>
              </div>
            </div>
          </div>
          <div class="cell">
            <label>대리점</label>
            <div class="form-group mt10">
              <input type="text" class="input-text" placeholder="대리점명"
                  v-model="searchOrderPartnerName"
                  @keyup.enter="searchBtn" >
            </div>
          </div>
        </div>
        <div class="row">
        </div>
        <div class="row">
          <div class="cell w100-p">
            <label class="mb0">실적 구분</label>
            <div class="cell_se_input">
              <a href="javascript:void(0);" @click="clkGubn('totalSum')">
								<span v-bind:class="{dviBtn: true, on: totalSumClass}">총계</span>
							</a>
              <a href="javascript:void(0);" @click="clkGubn('body')">
								<span v-bind:class="{dviBtn: true, on: bodyClass}">Body</span>
							</a>
              <a href="javascript:void(0);" @click="clkGubn('am')">
								<span v-bind:class="{dviBtn: true, on: amClass}">AM</span>
							</a>
              <a href="javascript:void(0);" @click="clkGubn('local')">
								<span v-bind:class="{dviBtn: true, on: localClass}">Local</span>
							</a>
            </div>
          </div>
        </div>
      </div>
      <!--  -->
    </div>
    <div class="sub_sh_btn_wrap">
      <button class="sh_btn" @click="searchBtn">조회</button>
    </div>
    <div class="sub_contents">
      <div class="sub_contents_wrap">
        <h1>컨텐츠</h1>
        <div class="board_list_top mb5 w100-p bgWhite">
          <div class="sub_left_wrap">
            <div class="destxt ">Working Day <span class="disin ml10">{{curWorkDay}} / {{totWorkDay}} 일</span></div>
          </div>
          <div class="sub_right_wrap">
            <div class="destxt">진척율 <span>{{workRate}}  %</span></div>
          </div>
        </div>
        <div class="board_list_top mb5">
          <div class="sub_right_wrap">
            <div class="btn_area pb0">
              <!-- <a href="javascript:void(0);" class="button white"><span>엑셀다운</span></a>
              <a href="javascript:void(0);" class="button white"><span>출력</span></a> -->
            </div>
          </div>
        </div>
        <div class="day_report mb10 pb0">
          <div class="day_box">
            <div class="title">
              <span>매출액 총계</span>
            </div>
            <div class="price">
              <span>{{Utils.numberComma(total)}}</span>원
            </div>
          </div>
          <div class="day_box">
            <div class="title">
              <span>BODY</span>
            </div>
            <div class="price">
              <span>{{Utils.numberComma(bodyTotal)}}</span>원
            </div>
          </div>
        </div>
        <div class="day_report bordn0 mb10 pt0">
          <div class="day_box">
            <div class="title">
              <span>AM</span>
            </div>
            <div class="price">
              <span>{{Utils.numberComma(amTotal)}}</span>원
            </div>
          </div>
          <div class="day_box">
            <div class="title">
              <span>LOCAL</span>
            </div>
            <div class="price">
              <span>{{Utils.numberComma(localTotal)}}</span>원
            </div>
          </div>
        </div>
        <div class="board_list_top mb5">
          <div class="sub_left_wrap">
            <div class="destxt02" style="top: 0px;">조회 <span>{{listTotCnt}} </span>건</div>
          </div>
          <div class="sub_right_wrap">
            <div class="btn_area pb0">

            </div>
          </div>
        </div>
        <div class="board_list type03 tbl_box">
          <table class="board_table" style="table-layout:fixed; width:1570px;">
            <!-- 지정(주문일, 구분, 상품명, 금액) 항목만 -->
            <caption class="hide">조회 테이블</caption>
            <colgroup>
              <col style="width:70px;">
              <col style="width:75px;">
              <col style="width:75px;">
              <col style="width:75px;">
              <col style="width:75px;">
              <col style="width:75px;">
              <col style="width:75px;">
              <col style="width:75px;">
              <col style="width:75px;">
              <col style="width:75px;">
              <col style="width:75px;">
              <col style="width:75px;">
              <col style="width:75px;">
              <col style="width:75px;">
              <col style="width:75px;">
              <col style="width:75px;">
              <col style="width:75px;">
              <col style="width:75px;">
              <col style="width:75px;">
              <col style="width:75px;">
              <col style="width:75px;">
            </colgroup>
            <thead>
              <tr>
                <th style="color: #ffffff; background: #dad5cf; border-bottom: 2px solid #555555;" scope="col"></th>
                <th style="color: #ffffff; background: #dad5cf; border-bottom: 2px solid #555555;" scope="col" colspan="4" >금월</th>
                <th style="color: #ffffff; background: #dad5cf; border-bottom: 2px solid #555555;" scope="col" colspan="4" >전월</th>
                <th style="color: #ffffff; background: #dad5cf; border-bottom: 2px solid #555555;" scope="col" colspan="4" >전년</th>
                <th style="color: #ffffff; background: #dad5cf; border-bottom: 2px solid #555555;" scope="col" colspan="4" >전월비</th>
                <th style="color: #ffffff; background: #dad5cf; border-bottom: 2px solid #555555;" scope="col" colspan="4" >전년비</th>
              </tr>
              <tr>
                <th scope="col">구분</th>
                <th scope="col">누적매출액</th>
                <th scope="col">일평균매출액</th>
                <th scope="col">매출이익액</th>
                <th scope="col">이익율</th>
                <th scope="col">누적매출액</th>
                <th scope="col">일평균매출액</th>
                <th scope="col">매출이익액</th>
                <th scope="col">이익율</th>
                <th scope="col">누적매출액</th>
                <th scope="col">일평균매출액</th>
                <th scope="col">매출이익액</th>
                <th scope="col">이익율</th>
                <th scope="col">누적매출액</th>
                <th scope="col">일평균매출액</th>
                <th scope="col">매출이익액</th>
                <th scope="col">이익율</th>
                <th scope="col">누적매출액</th>
                <th scope="col">일평균매출액</th>
                <th scope="col">매출이익액</th>
                <th scope="col">이익율</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data, index) in resultList" v-bind:key="index">
                <td class="tal" scope="col">{{data.brandName}}</td>
                <td class="tar" scope="col">{{renderNumber(data.thisSalePrice)}}</td>
                <td class="tar" scope="col">{{renderNumber(data.thisAvgDay)}}</td>
                <td class="tar" scope="col">{{renderNumber(data.thisProfit)}}</td>
                <td scope="col">{{data.thisProfitRate}}</td>
                <td class="tar" scope="col">{{renderNumber(data.lastMonthSalePrice)}}</td>
                <td class="tar" scope="col">{{renderNumber(data.lastMonthAvgDay)}}</td>
                <td class="tar" scope="col">{{renderNumber(data.lastMonthProfit)}}</td>
                <td scope="col">{{data.lastMonthProfitRate}}</td>
                <td class="tar" scope="col">{{renderNumber(data.lastYearSalePrice)}}</td>
                <td class="tar" scope="col">{{renderNumber(data.lastYearAvgDay)}}</td>
                <td class="tar" scope="col">{{renderNumber(data.lastYearProfit)}}</td>
                <td scope="col">{{data.lastYearProfitRate}}</td>
                <td class="tar" scope="col">{{renderNumber(data.compareLastMonthSalePrice)}}</td>
                <td class="tar" scope="col">{{renderNumber(data.compareLastMonthAvgDay)}}</td>
                <td class="tar" scope="col">{{renderNumber(data.compareLastMonthProfit)}}</td>
                <td scope="col">{{data.compareLastMonthProfitRate}}</td>
                <td class="tar" scope="col">{{renderNumber(data.compareLastYearSalePrice)}}</td>
                <td class="tar" scope="col">{{renderNumber(data.compareLastYearAvgDay)}}</td>
                <td class="tar" scope="col">{{renderNumber(data.compareLastYearProfit)}}</td>
                <td scope="col">{{data.compareLastYearProfitRate}}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- <div class="board_list_bottom">
          <div class="sub_center_wrap">
            <div class="btn_area pt0">
              <a class="button white"><span>신규</span></a>
              <a class="button dark"><span>수정</span></a>
              <a class="button blue"><span>삭제</span></a>
            </div>
          </div>
        </div> -->
  		</div>
    </div>
  </section>
</template>

<script>
import Vue from 'vue'
import router from '@/router'
import AppConfig from '@/config'
import Utils from '@/modules/utils'
import Grid from '@/components/Grid'
import GridModule from '@/modules/grid'
import InputDate from '@/components/InputDate'
import SelectCodeList from '@/components/SelectCodeList'

export default {
  name: 'sellingClosingActualResult',
	components: { InputDate, Grid, SelectCodeList },
	data () {
		return {
      AppConfig,
      Utils,
      fromDate : Utils.getToday(),
      toDate : Utils.getToday(),
      searchOrderPartnerName: '',
			isAllCnt: 0,
			totalSumClass: true,
			bodyClass: false,
			amClass: false,
      localClass: false,
      resultList: [],
      listTotCnt: 0,
      curWorkDay: 0,
      totWorkDay: 0,
      workRate: 0,
      total: 0,
      bodyTotal: 0,
      amTotal: 0,
      localTotal: 0,
		}
	},
	methods: {
		setSrchParamInit() { // 검색 조건값 초기화
      var today = new Date();
      var yyyy = today.getFullYear();

      this.stDate = Utils.getToday();
		},
		clkGubn(clsf) {
      this.bodyClass = false;
      this.amClass = false;
      this.localClass = false;
      this.totalSumClass = false;
			switch (clsf) {
				case 'body' :
					this.isAllCnt += 1;
					this.bodyClass = true;
					break;
				case 'am' :
					this.isAllCnt += 1;
					this.amClass = true;
					break;
				case 'local':
					this.isAllCnt += 1;
					this.localClass = true;
					break;
				case 'totalSum':
					this.isAllCnt = 3;
					this.totalSumClass = true;
					break;
				default:
					break;
			}
			
		},
		searchBtn() {
      const searchUrl = '/report/daily/list';
      const params = {
        fromDate: this.fromDate,
        toDate: this.toDate,
        
        searchType: '',
        searchOrderPartnerName: this.searchOrderPartnerName.toUpperCase()
      }

      if (this.totalSumClass == true) {
        params.searchType = '';
      }

      if (this.bodyClass == true) {
        params.searchType = 10
      }

      if (this.amClass == true) {
        params.searchType = 20
      }

      if (this.localClass == true) {
        params.searchType = 30
      }

      this.resultList = [];
      this.listTotCnt = 0;

      Utils.showLoading('loading_grid_resultList');
      
      Vue.httpClient
        .get(searchUrl, {params})
        .then(response => {
          if (response.data.result && response.data.status == AppConfig.HTTP_RESPONSE_SUCCESS) {
            this.resultList = response.data.result;
            this.listTotCnt = this.resultList.length;

            this.sumTotal(); // 총 계산
          }
        })
				.finally(_ => {
					Utils.hideLoading('loading_grid_resultList');
				});
			
      Vue.httpClient
        .get('/report/workdayFromTo', {params})
        .then((response) => {
          if (response.data.status == AppConfig.HTTP_RESPONSE_SUCCESS) {
            this.curWorkDay = response.data.result.curWorkDay;
            this.totWorkDay = response.data.result.totWorkDay;
            this.workRate   = response.data.result.workRate;
          }

        });
		},
    sumTotal() {
      var data = this.resultList;
      this.total = 0;
      this.bodyTotal = 0;
      this.amTotal = 0;
      this.localTotal = 0;

      for (var i in data) {
        this.bodyTotal += data[i].bodyPrice * 1;
        this.amTotal += data[i].amPrice * 1;
        this.localTotal += data[i].localPrice * 1;
      }
      this.total = this.bodyTotal + this.amTotal + this.localTotal;
    },
    renderNumber(val) {
      if ((val * 1) < 0) {
        let temp = Utils.numberComma( Math.abs(val) );
        return `- ${temp}`;
      }
      return Utils.numberComma(val);
    }
	},
	mounted() {
    this.$nextTick(function() {
      const $this = this;
      this.setSrchParamInit(); // 검색 조건값 초기화
      this.searchBtn();
		});
	},
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/report/SellingClosingActualResult.vue